import { render, staticRenderFns } from "./eventsPage.vue?vue&type=template&id=6db3be2a&scoped=true&"
import script from "./eventsPage.vue?vue&type=script&lang=js&"
export * from "./eventsPage.vue?vue&type=script&lang=js&"
import style0 from "./eventsPage.vue?vue&type=style&index=0&id=6db3be2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db3be2a",
  null
  
)

export default component.exports